module.exports = __webpack_public_path__ + "ae0f2ae6d1405ce988d98a44a41a5654.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/feedbacks/review-4.png
// module id = en9L
// module chunks = 0